/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Password_Requires_Non_AlphanumericInputs */

const nl_auth_password_errors_password_requires_non_alphanumeric = /** @type {(inputs: Auth_Password_Errors_Password_Requires_Non_AlphanumericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het wachtwoord moet minimaal één speciaal teken bevatten`)
};

/**

* @param {Auth_Password_Errors_Password_Requires_Non_AlphanumericInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_password_requires_non_alphanumeric = /** @type {((inputs?: Auth_Password_Errors_Password_Requires_Non_AlphanumericInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Password_Requires_Non_AlphanumericInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_password_requires_non_alphanumeric(inputs)
});
export { auth_password_errors_password_requires_non_alphanumeric as "auth.password_errors.password_requires_non_alphanumeric" }